import { useState } from "react";
import { Link } from "react-router-dom";
import {
  Bars3Icon,
  XMarkIcon,
  ChevronDownIcon,
} from "@heroicons/react/24/outline";

import logo from "../Images/logo cover.jpg";

const Navbar = () => {
  const [mobileMenu, setMobileMenu] = useState(false);
  const [aboutOpen, setAboutOpen] = useState(false);
  const [serviceOpen, setServiceOpen] = useState(false);

  const closeAll = () => {
    setMobileMenu(false);
    setAboutOpen(false);
    setServiceOpen(false);
  };

  return (
    <nav className="sticky top-0 z-50 bg-white shadow-lg border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-5 lg:px-10">
        <div className="flex justify-between items-center h-20">

          {/* Logo */}

          <Link
            to="/"
            className="flex items-center gap-3"
            onClick={closeAll}
          >
            <Link
              to="/"
              onClick={() => {
                closeAll();
                window.scrollTo({
                  top: 0,
                  behavior: "smooth",
                });
              }}
            >
              <img
                src={logo}
                alt="Narenth Logo"
                className="h-14 w-auto rounded-md cursor-pointer"
              />
            </Link>

            <div className="hidden md:block">
              <h1 className="text-xl font-bold text-slate-900">
                EDRS
              </h1>

              <p className="text-xs text-amber-600 tracking-widest uppercase">
                Rebar Estimation
              </p>
            </div>
          </Link>

          {/* Desktop Menu */}

          <div className="hidden md:flex items-center gap-8 font-medium text-gray-700">

            <Link
              to="/"
              className="hover:text-amber-500 transition"
            >
              Home
            </Link>

            {/* About */}

            <div className="relative group">

              <button className="flex items-center gap-1 hover:text-amber-500 transition">
                About Us
                <ChevronDownIcon className="h-4 w-4" />
              </button>

              <div className="absolute left-0 top-full pt-2 hidden group-hover:block z-50">

                <div className="w-56 bg-white rounded-xl shadow-xl border">

                  <Link
                    to="/aboutus"
                    className="block px-5 py-3 hover:bg-amber-50 hover:text-amber-600"
                  >
                    Overview
                  </Link>

                  <Link
                    to="/aboutus/keypersonals"
                    className="block px-5 py-3 hover:bg-amber-50 hover:text-amber-600"
                  >
                    Key Personals
                  </Link>

                </div>

              </div>

            </div>

            {/* Services */}

            <div className="relative group">

              <button className="flex items-center gap-1 hover:text-amber-500 transition">
                Services
                <ChevronDownIcon className="h-4 w-4" />
              </button>

              <div className="absolute left-0 top-full pt-2 hidden group-hover:block z-50">

                <div className="w-64 bg-white rounded-xl shadow-xl border">

                  <Link
                    to="/services/rebar-estimation"
                    className="block px-5 py-3 hover:bg-amber-50 hover:text-amber-600"
                  >
                    Rebar Estimation
                  </Link>

                  <Link
                    to="/services/excel"
                    className="block px-5 py-3 hover:bg-amber-50 hover:text-amber-600"
                  >
                    Excel
                  </Link>

                  <Link
                    to="/services/asa"
                    className="block px-5 py-3 hover:bg-amber-50 hover:text-amber-600"
                  >
                    aSa Estimating
                  </Link>

                </div>

              </div>

            </div>

            <Link
              to="/projects"
              className="hover:text-amber-500 transition"
            >
              Projects
            </Link>

            <Link
              to="/careers"
              className="hover:text-amber-500 transition"
            >
              Careers
            </Link>

            <Link
              to="/contact"
              className="bg-amber-500 text-white px-6 py-2 rounded-lg hover:bg-amber-600 transition"
            >
              Contact
            </Link>

          </div>

          {/* Mobile Button */}

          <button
            onClick={() => setMobileMenu(!mobileMenu)}
            className="md:hidden"
          >
            {mobileMenu ? (
              <XMarkIcon className="w-8 h-8" />
            ) : (
              <Bars3Icon className="w-8 h-8" />
            )}
          </button>

        </div>
      </div>

      {/* Mobile Menu */}

      {mobileMenu && (

        <div className="md:hidden bg-white border-t shadow-md">

          <Link
            to="/"
            onClick={closeAll}
            className="block px-6 py-4 border-b"
          >
            Home
          </Link>

          {/* About */}

          <button
            onClick={() => setAboutOpen(!aboutOpen)}
            className="w-full text-left px-6 py-4 border-b flex justify-between"
          >
            About Us

            <ChevronDownIcon
              className={`w-5 transition ${aboutOpen ? "rotate-180" : ""
                }`}
            />
          </button>

          {aboutOpen && (
            <div className="bg-gray-50">

              <Link
                to="/aboutus"
                onClick={closeAll}
                className="block px-10 py-3"
              >
                Overview
              </Link>

              <Link
                to="/aboutus/keypersonals"
                onClick={closeAll}
                className="block px-10 py-3"
              >
                Key Personals
              </Link>

            </div>
          )}

          {/* Services */}

          <button
            onClick={() => setServiceOpen(!serviceOpen)}
            className="w-full text-left px-6 py-4 border-b flex justify-between"
          >
            Services

            <ChevronDownIcon
              className={`w-5 transition ${serviceOpen ? "rotate-180" : ""
                }`}
            />
          </button>

          {serviceOpen && (

            <div className="bg-gray-50">

              <Link
                to="/services/rebar-estimation"
                onClick={closeAll}
                className="block px-10 py-3"
              >
                Rebar Estimation
              </Link>

              <Link
                to="/services/excel"
                onClick={closeAll}
                className="block px-10 py-3"
              >
                Excel
              </Link>

              <Link
                to="/services/asa"
                onClick={closeAll}
                className="block px-10 py-3"
              >
                aSa Software
              </Link>

            </div>
          )}

          <Link
            to="/projects"
            onClick={closeAll}
            className="block px-6 py-4 border-b"
          >
            Projects
          </Link>

          <Link
            to="/careers"
            onClick={closeAll}
            className="block px-6 py-4 border-b"
          >
            Careers
          </Link>

          <Link
            to="/contact"
            onClick={closeAll}
            className="block px-6 py-4 bg-amber-500 text-white text-center"
          >
            Contact
          </Link>

        </div>

      )}
    </nav>
  );
};

export default Navbar;